/**
 * Authoring-queue helpers — detect Goals whose carer-guidance still
 * carries the post-OMON-079-reseed placeholder skeleton ("Replace this
 * paragraph"). Drives the librarian's "Show only goals with unauthored
 * guidance" filter (OMON-079 79f) and its accompanying counter chip.
 *
 * Substring-match against `_activityDefinition.documentation[].display`.
 * Any of the 5 levels carrying the marker qualifies the Goal as
 * unauthored. The marker string lives inside the per-level Markdown
 * skeletons emitted by `agent.fhir/scripts/reseed_catalogue_v4.py`
 * during --derive; once Jo replaces every "Replace this paragraph"
 * line, the goal drops out of the queue.
 */

import { state } from "../state";

const PLACEHOLDER_MARKER = "Replace this paragraph";

export function hasPlaceholderText(goalId: string): boolean {
  const ad = state.activityData.get(goalId);
  if (!ad?.documentation) return false;
  return ad.documentation.some(
    (d) => typeof d?.display === "string" && d.display.includes(PLACEHOLDER_MARKER),
  );
}

export function countPlaceholderGoals(): number {
  let count = 0;
  for (const id of state.catalogueData.keys()) {
    if (hasPlaceholderText(id)) count++;
  }
  return count;
}
